"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriversListWidget = void 0;
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var core_1 = require("@material-ui/core");
var services_1 = require("@falcon/services");
var DriversListWidget = /** @class */ (function (_super) {
    __extends(DriversListWidget, _super);
    function DriversListWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = _this.getSetting("vehicleIndex", 0);
        _this.driversPerAccount = _this.getSetting("driversPerAccount");
        _this.handleOnClickEvent = _this.handleOnClickEvent.bind(_this);
        _this.deleteDriver = _this.deleteDriver.bind(_this);
        _this.editDriver = _this.editDriver.bind(_this);
        _this.addDriver = _this.addDriver.bind(_this);
        return _this;
    }
    DriversListWidget.prototype.componentDidMount = function () {
        var _a;
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        var allDrivers = [this.props.interaction.policyHolder].concat((_a = this.props.interaction.additionalDrivers) !== null && _a !== void 0 ? _a : []);
        var drivers;
        // Set policyholder as main driver if no drivers set for the vehicle
        if (!vehicle.driverIds || vehicle.driverIds.length === 0) {
            vehicle.driverIds = [this.props.interaction.policyHolder.personId];
            vehicle.mainDriverId = this.props.interaction.policyHolder.personId;
            vehicle.numberOfDrivers += 1;
            if (this.props.interaction.additionalDrivers !== null) {
                for (var _i = 0, _b = this.props.interaction.additionalDrivers; _i < _b.length; _i++) {
                    var additionalDriver = _b[_i];
                    vehicle.driverIds.push(additionalDriver.personId);
                    vehicle.numberOfDrivers += 1;
                }
            }
        }
        drivers = allDrivers.map(function (driver) { return vehicle.driverIds.find(function (driverId) { return driverId === driver.personId; }); });
        this.setState({
            drivers: drivers,
            allDrivers: allDrivers,
        });
    };
    DriversListWidget.prototype.renderInputField = function () {
        var _a, _b;
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        var registrationNumber = vehicle.registrationNumber ? " (".concat(vehicle.registrationNumber, ")") : '';
        var vehicleInformation = "".concat(vehicle.make, " ").concat(vehicle.model).concat(registrationNumber);
        var label = "Who are the drivers of this ".concat(vehicleInformation, "?");
        return (React.createElement("div", { className: "falcon-checkbox form-group checkbox-margin-top-20 driver-list-wdg" },
            React.createElement("label", { className: "no-outline" }, label),
            React.createElement(core_1.List, { "aria-label": label }, this.renderDrivers()),
            (((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.allDrivers) === null || _b === void 0 ? void 0 : _b.length) < this.driversPerAccount) &&
                React.createElement(react_router_dom_1.Link, { className: "add-another-driver", to: "#", onClick: this.addDriver }, "Add another driver")));
    };
    DriversListWidget.prototype.renderDrivers = function () {
        var _this = this;
        var _a;
        return (_a = this.state) === null || _a === void 0 ? void 0 : _a.allDrivers.map(function (driver, index) { return React.createElement(core_1.ListItem, { key: "key-".concat(driver.personId) },
            React.createElement("div", { className: "wolf-checkbox" },
                React.createElement("label", { className: "checkbox-label", htmlFor: driver.personId },
                    React.createElement("input", { onChange: _this.handleOnClickEvent, type: "checkbox", "aria-label": "".concat(driver.firstName, " ").concat(driver.lastName), id: driver.personId, checked: _this.state.drivers.some(function (driverId) { return driverId === driver.personId; }), disabled: index === 0 }),
                    React.createElement("span", { className: "mb-0 driver-name ".concat(index === 0 ? "disabled-label" : "") },
                        driver.firstName,
                        " ",
                        driver.lastName),
                    React.createElement("div", { className: "driver-links" },
                        React.createElement(react_router_dom_1.Link, { className: "ml-2 pt-1 edit-driver-link", to: "#", id: "edit-".concat(index), onClick: _this.editDriver }, "Edit"),
                        (index > 0) && React.createElement(react_router_dom_1.Link, { className: "ml-2 pt-1 edit-driver-link remove-driver", to: "#", id: "delete-".concat(driver.personId), onClick: _this.deleteDriver }, "Delete"))))); });
    };
    DriversListWidget.prototype.handleOnClickEvent = function (event) {
        var _a;
        var changeDriverId = event.target.id;
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        if (changeDriverId === vehicle.mainDriverId) {
            return;
        }
        var driverIds;
        if (this.state.drivers.includes(changeDriverId)) {
            driverIds = this.state.drivers.filter(function (item) { return item !== changeDriverId; });
        }
        else {
            driverIds = __spreadArray(__spreadArray([], this.state.drivers, true), [changeDriverId], false);
        }
        vehicle.driverIds = driverIds;
        vehicle.numberOfDrivers = driverIds.length;
        this.setState({ drivers: driverIds });
        var madeChanges = (_a = this.props.interaction.uistate.changes) !== null && _a !== void 0 ? _a : [];
        if (driverIds.length === this.state.allDrivers.length) {
            madeChanges = madeChanges.filter(function (e) { return e !== "removeDriver"; });
        }
        else {
            madeChanges.push("removeDriver");
        }
        this.props.onStateChange('uistate.changes', madeChanges);
        this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "]"), vehicle);
        this.changelogRecorder.recordPage("change", this.props, "vehicles[".concat(this.vehicleIndex, "]"));
    };
    DriversListWidget.prototype.deleteDriver = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var driverId, vehicle, driverIds, allDrivers, additionalDrivers;
            var _this = this;
            return __generator(this, function (_a) {
                driverId = event.target.id;
                driverId = driverId.replace("delete-", "");
                vehicle = this.props.interaction.vehicles[this.vehicleIndex];
                driverIds = vehicle.driverIds.filter(function (id) { return id !== driverId; });
                vehicle.driverIds = driverIds;
                vehicle.numberOfDrivers = driverIds.length;
                allDrivers = this.state.allDrivers.filter(function (driver) { return driver.personId !== driverId && driver.personId; });
                this.setState({ drivers: driverIds, allDrivers: allDrivers });
                this.props.onStateChange("vehicles[".concat(this.vehicleIndex, "]"), vehicle);
                this.changelogRecorder.recordPage("change", this.props, "vehicles[".concat(this.vehicleIndex, "]"));
                additionalDrivers = allDrivers.filter(function (driver) { return driver.personId !== _this.props.interaction.policyHolder.personId; });
                this.props.onStateChange('additionalDrivers', additionalDrivers);
                this.changelogRecorder.recordPage("change", this.props, "additionalDrivers");
                return [2 /*return*/];
            });
        });
    };
    DriversListWidget.prototype.editDriver = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var driverId, driverIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        driverId = event.target.id;
                        driverId = driverId.replace("edit-", "");
                        driverIndex = +driverId;
                        driverIndex = driverIndex - 1;
                        if (!(this.props.interaction.process === "nb")) return [3 /*break*/, 5];
                        if (!(driverId === "0")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.engine.navigate("drivingLicenceScan", false)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.props.engine.navigate("editAdditionalDriver".concat(driverId, "DrivingLicenceScanPage"), false)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 11];
                    case 5:
                        if (!(this.props.interaction.process === "renewal")) return [3 /*break*/, 10];
                        if (!(driverId === "0")) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.props.engine.navigate("presetDriverPolicyHolder", false)];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this.props.engine.navigate("presetDriver".concat(driverIndex), false)];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        if (driverId === "0") {
                            window.location.href = "/journey/init/product/".concat(services_1.PRODUCT_NAME_WOLF_MOTOR, "/process/mtaEditDriverDetails/presetDriverPolicyHolder/").concat(this.props.interaction._id);
                        }
                        else {
                            window.location.href = "/journey/init/product/".concat(services_1.PRODUCT_NAME_WOLF_MOTOR, "/process/mtaEditDriverDetails/presetDriver").concat(driverIndex, "/").concat(this.props.interaction._id);
                        }
                        _a.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    DriversListWidget.prototype.addDriver = function () {
        return __awaiter(this, void 0, void 0, function () {
            var driverIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        driverIndex = this.state.allDrivers.length;
                        if (!(this.props.interaction.process === "nb")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.engine.navigate("additionalDriver".concat(driverIndex, "DrivingLicenceScanPage"), false)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 2:
                        if (!(this.props.interaction.process === "renewal")) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.props.engine.navigate('addDriverPresetPage', false)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        window.location.href = "/journey/init/product/".concat(services_1.PRODUCT_NAME_WOLF_MOTOR, "/process/mtaAddPermanentDriver/preset/").concat(this.props.interaction._id);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return DriversListWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.DriversListWidget = DriversListWidget;
//# sourceMappingURL=DriversListWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/motorCommon/DriversListWidget.js
// module id = 3325
// module chunks = 0